export default {
  'menu.welcome': 'Bienvenido',
  'menu.more-blocks': 'Más bloques',
  'menu.home': 'Inicio',
  'menu.admin': 'Administrador',
  'menu.console.sub-page': 'Subpágina',
  'menu.login': 'Iniciar sesión',
  'menu.register': 'Registrarse',
  'menu.register-result': 'Resultado del registro',
  'menu.dashboard': 'Panel',
  'menu.dashboard.analysis': 'Análisis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Área de trabajo',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Formulario',
  'menu.form.basic-form': 'Formulario básico',
  'menu.form.step-form': 'Formulario por pasos',
  'menu.form.step-form.info': 'Formulario por pasos (escribir información de transferencia)',
  'menu.form.step-form.confirm': 'Formulario por pasos (confirmar información de transferencia)',
  'menu.form.step-form.result': 'Formulario por pasos (finalizado)',
  'menu.form.advanced-form': 'Formulario avanzado',
  'menu.list': 'Lista',
  'menu.list.table-list': 'Tabla de búsqueda',
  'menu.list.basic-list': 'Lista básica',
  'menu.list.card-list': 'Lista de tarjetas',
  'menu.list.search-list': 'Lista de búsqueda',
  'menu.list.search-list.articles': 'Lista de búsqueda (artículos)',
  'menu.list.search-list.projects': 'Lista de búsqueda (proyectos)',
  'menu.list.search-list.applications': 'Lista de búsqueda (aplicaciones)',
  'menu.profile': 'Perfil',
  'menu.profile.basic': 'Perfil básico',
  'menu.profile.advanced': 'Perfil avanzado',
  'menu.result': 'Resultado',
  'menu.result.success': 'Éxito',
  'menu.result.fail': 'Fallo',
  'menu.exception': 'Excepción',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Disparador',
  'menu.account': 'Cuenta',
  'menu.account.center': 'Centro de cuenta',
  'menu.account.settings': 'Configuración de la cuenta',
  'menu.account.trigger': 'Error de disparador',
  'menu.account.logout': 'Cerrar sesión',
  'menu.account.profile': 'Perfil',

  'menu.admin.dashboard': 'tablero',
  'menu.admin.settings': 'ajustes',
  'menu.admin.providers': 'proveedores',
  'menu.admin.unbindDevice': 'desvincularDispositivo',
  'menu.admin.userManage': 'gestiónDeUsuarios',
  'menu.console': 'consola',
  'menu.console.agents': 'agentes',
  'menu.console.agentDevice': 'dispositivoAgente',
  'menu.console.devices': 'dispositivos',
  'menu.console.speakers': 'Reconocimiento de hablantes',
  'menu.console.voiceClone': 'Clonación de voz',
  'menu.console.settings': 'Configuración personal',
  'menu.admin.deviceManage': 'Gestión de dispositivos',

  'menu.console.agentSetting': 'Configuración de agente',
};
